import React from "react"
import ReactDOM from "react-dom"
import * as serviceWorker from "./serviceWorker"
import client from "./modules/core/utils/connection"
import rootReducer from "./store/reducers"
import {Store} from "react-reducer-store"
import MasterLayout from "./modules/core/layouts/MasterLayout"
import {SnackbarProvider} from "notistack"
import {ApolloProvider} from "@apollo/client"
import FilesContext from "./store/FilesContext"

import "./modules/core/layouts/styles/css/style.css" // global css

const App = (
  <ApolloProvider client={client}>
    <FilesContext>
      <SnackbarProvider
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        autoHideDuration={3000}
      >
        <Store rootReducer={rootReducer}>
          <MasterLayout/>
        </Store>
      </SnackbarProvider>
    </FilesContext>
  </ApolloProvider>
)

ReactDOM.render(App, document.getElementById("root"))

serviceWorker.unregister()
